module.exports = __webpack_public_path__ + "static/media/ic_validate_hover.4699609a.svg";